import { render, staticRenderFns } from "./ActionButtons.vue?vue&type=template&id=22c31b51"
import script from "./ActionButtons.vue?vue&type=script&lang=ts"
export * from "./ActionButtons.vue?vue&type=script&lang=ts"
import style0 from "./ActionButtons.vue?vue&type=style&index=0&id=22c31b51&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports